import { LI, Notice, UL } from '@vapor/ui';
import { AcademyLayout, AcademyMain, AcademyTitle } from '../../layout/academyLayout';

export default () => {
  return (
    <AcademyLayout active="customize">
      <AcademyTitle>Customize Weekrise</AcademyTitle>

      <AcademyMain>
        <p>
          It's our belief that everybody works differently. That's why we've made it possible
          to customize Weekrise to your liking.
        </p>
        <Notice>
          We are always open to feedback and suggestions. Please let us know if there is some
          switch you would like us to add to make you more productive.
        </Notice>
        <p>
          To customize Weekrise, click on the three dots in the top-right corner and select
          'Settings'. Then, choose 'Customization'. Here you will find a bunch of things you
          can select or toggle.
        </p>
        <p>Some of the things you can change are:</p>
        <UL>
          <LI>Dark or light mode</LI>
          <LI>Start of the Week</LI>
          <LI>Date format</LI>
          <LI>How unfinished tasks should behave</LI>
          <LI>How you want us to indicate that a task is finished</LI>
          <LI>Wether we should open newly created tasks</LI>
          <LI>and more</LI>
        </UL>
        <p>
          You can also use the settings panel to customize the length of a Pomodoro and to
          change the name of your calendar.
        </p>
      </AcademyMain>
    </AcademyLayout>
  );
};
